import { setUserData } from '@/auth/utils'
import EventBus from '@/event-bus'

export default {
  async handle(data) {
    await setUserData()
    EventBus.$emit('profile-updated')
  },
}
